import instance from 'api';
import { AxiosRequestConfig } from 'axios';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IArea, IServiceOrg, IServiceOrgListParamsRow } from './interfaces';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';

export const getServiceOrgList = (data: IDynamicTableParams) => {
  return instance(true)
    .post<IServiceOrg[]>('/serviceOrg/list', data)
    .then((response) => response.data);
};

export const getServiceOrgListParams = (params?: { name?: string }, config?: AxiosRequestConfig) => {
  return instance()
    .get<IServiceOrgListParamsRow[]>('/serviceOrg/listParams', { ...config, params })
    .then((response) => response.data);
};

export const getServiceOrgAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/serviceOrg/availableColumns')
    .then((response) => response.data);
};

export const getServiceOrgAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/serviceOrg/availableGroupColumns')
    .then((response) => response.data);
};

export const loadServiceOrg = (serviceOrgGuid: string) => {
  return instance()
    .get<IServiceOrg>(`/serviceOrg/load/${serviceOrgGuid}`)
    .then((response) => response.data);
};

export const createServiceOrg = (serviceOrg: IServiceOrg) => {
  return instance()
    .post<IServiceOrg>(`/serviceOrg/save`, serviceOrg)
    .then((response) => response.data);
};

export const updateServiceOrg = (serviceOrg: IServiceOrg) => {
  return instance()
    .post<IServiceOrg>(`/serviceOrg/${serviceOrg.serviceOrgGuid}/update`, serviceOrg)
    .then((response) => response.data);
};

export const archiveServiceOrg = (serviceOrgGuid: string) => {
  return instance()
    .post(`/serviceOrg/archive`, { serviceOrgGuid })
    .then((response) => response.data);
};

export const recoverServiceOrg = (serviceOrgGuid: string) => {
  return instance()
    .post(`/serviceOrg/recover`, { serviceOrgGuid })
    .then((response) => response.data);
};

// dictionaries
export const getAreas = () => {
  return instance()
    .post<IArea[]>('/area/list', {})
    .then((response) => response.data);
};
